// The band at the foot of a workspace pane with no workspace, for what the
// pane shows to lay cells of its own in, beside the pane's: the blank page's
// parts. Null where there is no such band.
import { createContext, useContext } from "react";

export const PaneFootContext = createContext(null);
export const usePaneFoot = () => useContext(PaneFootContext);
